const clarificationsTitle = ["naming", "subcategory"];
const sizeClarificationsOnPage = 5;

export { clarificationsTitle, sizeClarificationsOnPage };
